/*
 * Public API Surface of ngx-date-picker
 */

export * from './datepicker/ngx-date-picker.service';
export * from './datepicker/ngx-date-picker.component';
export * from './datepicker/ngx-date-picker.module';
export * from './datepicker/ngx-date-picker.directive';

export { CustomConfig, ValueFormat } from './config/datePicker-config'